import { Navigate } from "react-router-dom";

import { useAuth } from "../core/auth";
import AdminLayout from "../Routes/admin/components/admin-layout";
import AdminHome from "../Routes/admin/home/page";
import AdminLogin from "../Routes/admin/login/page";
import AdminStoreSignupRequest from "../Routes/admin/store-signup-request/page";
import AdminStoreManagement from "../Routes/admin/store-management/page";
import AdminStoreReview from "../Routes/admin/store-review/page";
import AdminIssueCoupon from "../Routes/admin/issue-coupon/page";
import AdminNewStorePushAlarm from "../Routes/admin/new-store-push-alram/page";
import AdminStoreReserveTime from "../Routes/admin/store-reserve-time/page";
import AdminCancelOrder from "../Routes/admin/cancel-order/page";
import AdminCancelLiveOrder from "../Routes/admin/cancel-live-order/page";
import AdminPartialRefundOrder from "../Routes/admin/partial-refund-order/page";
import AdminMasterLogin from "../Routes/admin/master-login/page";
import AdminWhatMessageTheyReceive from "../Routes/admin/what-message-they-receive/page";
import AdminSellerPushAlarm from "../Routes/admin/seller-push-alarm/page";
import AdminConfirmPreOrderAsAutoConfirm from "../Routes/admin/confirm-pre-order-as-auto-confirm/page";
import AdminFrequencyMonitoring from "../Routes/admin/frequency-monitoring/page";
import AdminStoreDelete from "../Routes/admin/store-delete/page";
import AdminStoreHide from "../Routes/admin/store-hide/page";
import AdminCommunity from "../Routes/admin/community/page";
import AdminBossFeedback from "../Routes/admin/boss-feedback/page";
import AdminBossNotice from "../Routes/admin/boss-notice/page";
import AdminInactiveStores from "../Routes/admin/inactive-stores/page";
import AdminBannerManagement from "../Routes/admin/banner-management/page";
import AdminSettlementMatch from "../Routes/admin/settlement-match/page";
import AdminStoreCouponIssue from "../Routes/admin/store-coupon-issue/page";
import AdminSettleManagement from "../Routes/admin/settle-management/page";
import AdminLegacySettleManagement from "../Routes/admin/legacy-settle-management/page";
import AdminCancelParticipation from "../Routes/admin/cancel-participation/page";
import AdminUserDelete from "../Routes/admin/user-delete/page";
import AdminRestaurantDiscountWaitlistPush from "../Routes/admin/restaurant-discount-waitlist-push/page";
import AdminManagerCreate from "../Routes/admin/manager-create/page";
import AdminFeeFreeUntil from "../Routes/admin/fee-free-until/page";
import AdminStoreSearchKeyword from "../Routes/admin/store-search-keyword/page";
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- used in route element
import AdminPackDiscountRateTier from "../Routes/admin/pack-discount-rate-tier/page";
import AdminPackOrderLimitConfig from "../Routes/admin/pack-order-limit-config/page";
import AdminUserNameChange from "../Routes/admin/user-name-change/page";
import AdminMonthlyOverview from "../Routes/admin/monthly-overview/page";
import AdvanceLedger from "../Routes/admin/advance-ledger/page";
import PayoutManagement from "../Routes/admin/payout-management/page";
import AdminTossPayoutSyncPage from "../Routes/admin/toss-payout-sync/page";
import PayoutPreview from "../Routes/admin/payout-preview/page";
import AdminLegacySettlementInfoEdit from "../Routes/admin/legacy-settlement-info-edit/page";
import AdminSellerScheduledPushOptOut from "../Routes/admin/seller-scheduled-push-opt-out/page";

const AdminAuth = ({ children }: { children: JSX.Element }) => {
  const { isAdministratorLoggedIn } = useAuth();

  if (isAdministratorLoggedIn) {
    return <AdminLayout>{children}</AdminLayout>;
  }

  return <Navigate to="/admin/login" />;
};

// prettier-ignore
export const adminRoutes = [
  {
    path: "/admin/home",
    element: (
      <AdminAuth>
        <AdminHome />
      </AdminAuth>
    ),
  },
  { path: "/admin/login", element: <AdminLayout><AdminLogin /></AdminLayout>, },
  {
    path: "/admin/store-signup-request",
    element: (
      <AdminAuth>
        <AdminStoreSignupRequest />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/store-management",
    element: (
      <AdminAuth>
        <AdminStoreManagement />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/manager-create",
    element: (
      <AdminAuth>
        <AdminManagerCreate />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/fee-free-until",
    element: (
      <AdminAuth>
        <AdminFeeFreeUntil />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/store-search-keyword",
    element: (
      <AdminAuth>
        <AdminStoreSearchKeyword />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/pack-discount-rate-tier",
    element: (
      <AdminAuth>
        <AdminPackDiscountRateTier />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/pack-order-limit-config",
    element: (
      <AdminAuth>
        <AdminPackOrderLimitConfig />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/user-name-change",
    element: (
      <AdminAuth>
        <AdminUserNameChange />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/store-review",
    element: (
      <AdminAuth>
        <AdminStoreReview />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/frequency-monitoring",
    element: (
      <AdminAuth>
        <AdminFrequencyMonitoring />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/issue-coupon",
    element: (
      <AdminAuth>
        <AdminIssueCoupon />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/new-store-push-alarm",
    element: (
      <AdminAuth>
        <AdminNewStorePushAlarm />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/store-reserve-time",
    element: (
      <AdminAuth>
        <AdminStoreReserveTime />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/cancel-order",
    element: (
      <AdminAuth>
        <AdminCancelOrder />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/cancel-live-order",
    element: (
      <AdminAuth>
        <AdminCancelLiveOrder />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/partial-refund-order",
    element: (
      <AdminAuth>
        <AdminPartialRefundOrder />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/master-login",
    element: (
      <AdminAuth>
        <AdminMasterLogin />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/what-message-they-receive",
    element: (
      <AdminAuth>
        <AdminWhatMessageTheyReceive />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/seller-push-alarm",
    element: (
      <AdminAuth>
        <AdminSellerPushAlarm />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/confirm-pre-order-as-auto-confirm",
    element: (
      <AdminAuth>
        <AdminConfirmPreOrderAsAutoConfirm />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/store-hide",
    element: (
      <AdminAuth>
        <AdminStoreHide />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/store-delete",
    element: (
      <AdminAuth>
        <AdminStoreDelete />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/community",
    element: (
      <AdminAuth>
        <AdminCommunity />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/boss-feedback",
    element: (
      <AdminAuth>
        <AdminBossFeedback />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/boss-notice",
    element: (
      <AdminAuth>
        <AdminBossNotice />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/inactive-stores",
    element: (
      <AdminAuth>
        <AdminInactiveStores />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/banner-management",
    element: (
      <AdminAuth>
        <AdminBannerManagement />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/settlement-match",
    element: (
      <AdminAuth>
        <AdminSettlementMatch />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/store-coupon-issue",
    element: (
      <AdminAuth>
        <AdminStoreCouponIssue />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/settle-management",
    element: (
      <AdminAuth>
        <AdminSettleManagement />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/legacy-settle-management",
    element: (
      <AdminAuth>
        <AdminLegacySettleManagement />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/cancel-participation",
    element: (
      <AdminAuth>
        <AdminCancelParticipation />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/user-delete",
    element: (
      <AdminAuth>
        <AdminUserDelete />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/restaurant-discount-waitlist-push",
    element: (
      <AdminAuth>
        <AdminRestaurantDiscountWaitlistPush />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/monthly-overview",
    element: (
      <AdminAuth>
        <AdminMonthlyOverview />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/advance-ledger",
    element: (
      <AdminAuth>
        <AdvanceLedger />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/payout-preview",
    element: (
      <AdminAuth>
        <PayoutPreview />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/payout-management",
    element: (
      <AdminAuth>
        <PayoutManagement />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/toss-payout-sync",
    element: (
      <AdminAuth>
        <AdminTossPayoutSyncPage />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/seller-scheduled-push-opt-out",
    element: (
      <AdminAuth>
        <AdminSellerScheduledPushOptOut />
      </AdminAuth>
    ),
  },
  {
    path: "/admin/legacy-settlement-info-edit",
    element: (
      <AdminAuth>
        <AdminLegacySettlementInfoEdit />
      </AdminAuth>
    ),
  },
];
